import { useMutation } from '@tanstack/react-query';
import { api } from '@/api';
import { queryClient } from '@/queries';
import { CreateReleaseNotePayload, UpdateReleaseNotePayload } from '@/api/apis/release-notes';
import { releaseNotesQueryKeys } from './release-notes.keys';

export const useCreateReleaseNoteMutation = () => {
  return useMutation({
    mutationFn: (payload: CreateReleaseNotePayload) => api.releaseNotes.createReleaseNote(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: releaseNotesQueryKeys.all,
      });
    },
  });
};

export const useUpdateReleaseNoteMutation = () => {
  return useMutation({
    mutationFn: ({ releaseNoteId, payload }: { releaseNoteId: string; payload: UpdateReleaseNotePayload }) =>
      api.releaseNotes.updateReleaseNote(releaseNoteId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: releaseNotesQueryKeys.all,
      });
    },
  });
};

export const useDeleteReleaseNoteMutation = () => {
  return useMutation({
    mutationFn: (releaseNoteId: string) => api.releaseNotes.deleteReleaseNote(releaseNoteId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: releaseNotesQueryKeys.all,
      });
    },
  });
};
